module.exports = __webpack_public_path__ + "img/input_active_icon.f2a0eeee.svg";